import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const projects = [
  {
    title: "Zilch's Digital Transformation",
    category: "Brand Design & Content Strategy",
    image: "https://images.unsplash.com/photo-1563986768494-4dee2763ff3f?auto=format&fit=crop&q=80",
    description: "Developed a comprehensive content strategy that helped Zilch achieve 300% increase in user engagement and establish itself as a fintech leader."
  },
  {
    title: "Smart's Mobile App Launch",
    category: "Digital Marketing",
    image: "https://images.unsplash.com/photo-1551434678-e076c223a692?auto=format&fit=crop&q=80",
    description: "Led the successful launch campaign for Smart's innovative mobile app, resulting in 1M+ downloads in the first month."
  },
  {
    title: "Wayflyer's Brand Evolution",
    category: "Brand Strategy",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&q=80",
    description: "Transformed Wayflyer's brand identity and content strategy, leading to a 200% increase in market visibility."
  },
  {
    title: "Green-Got's Sustainability Campaign",
    category: "Content Creation",
    image: "https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?auto=format&fit=crop&q=80",
    description: "Created an impactful sustainability campaign that positioned Green-Got as a leader in eco-friendly banking."
  },
  {
    title: "Mangopay's Market Expansion",
    category: "Growth Strategy",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&q=80",
    description: "Executed a multi-channel content strategy that supported Mangopay's successful expansion into new markets."
  },
  {
    title: "Culture Kings' Social Success",
    category: "Social Media Strategy",
    image: "https://images.unsplash.com/photo-1542291026-7eec264c27ff?auto=format&fit=crop&q=80",
    description: "Developed and executed a social media strategy that doubled Culture Kings' engagement rates and sales conversions."
  },
  {
    title: "Huffer's Digital Presence",
    category: "Digital Transformation",
    image: "https://images.unsplash.com/photo-1445205170230-053b83016050?auto=format&fit=crop&q=80",
    description: "Revamped Huffer's online presence, resulting in a 150% increase in e-commerce sales and brand engagement."
  },
  {
    title: "Frankster Australia Campaign",
    category: "Brand Awareness",
    image: "https://images.unsplash.com/photo-1493612276216-ee3925520721?auto=format&fit=crop&q=80",
    description: "Created a viral brand awareness campaign that established Frankster as a leading fashion retailer in Australia."
  },
  {
    title: "Cuyana's Sustainable Story",
    category: "Content & Storytelling",
    image: "https://images.unsplash.com/photo-1490481651871-ab68de25d43d?auto=format&fit=crop&q=80",
    description: "Crafted a compelling brand narrative that highlighted Cuyana's commitment to sustainable fashion and conscious consumption."
  }
];

export default function Work() {
  const navigate = useNavigate();

  const handleProjectStart = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate('/contact');
  };

  return (
    <div className="page-container">
      <div className="content-container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h1 className="float-slow">Our <span className="text-golden">Work</span></h1>
          <p className="text-xl text-gray-300 float-medium">
            Transforming brands through strategic creativity and measurable results
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {projects.map((project, index) => (
            <motion.div
              key={project.title}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className={`group relative overflow-hidden rounded-2xl bg-black/30 border border-gray-800 hover:border-golden transition-all duration-300 float-${index % 2 === 0 ? 'slow' : 'medium'}`}
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent opacity-100 transition-opacity duration-300" />
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-6 transform translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
                <span className="inline-block px-3 py-1 bg-golden/20 border border-golden/30 rounded-full text-golden text-sm font-medium mb-3 float-fast">
                  {project.category}
                </span>
                <h3 className="text-xl font-bold text-white mb-2">{project.title}</h3>
                <p className="text-gray-300 text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300 delay-100">
                  {project.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-2xl mx-auto mb-16"
        >
          <h2 className="text-3xl font-bold mb-4 float-slow">
            Ready to be our next <span className="text-golden">success story</span>?
          </h2>
          <p className="text-gray-300 mb-8 float-medium">
            Let's create something extraordinary together. Our proven track record speaks for itself.
          </p>
          <button
            onClick={handleProjectStart}
            className="inline-flex items-center px-8 py-4 bg-golden text-white rounded-full text-lg font-semibold hover:bg-golden-600 transition-colors duration-300 float-fast"
          >
            Start Your Project
          </button>
        </motion.div>
      </div>
    </div>
  );
}